import React from 'react';
import ContractDetail from '../components/UI/contracts/detail/ContractDetail';
import { useNavigate, useParams } from 'react-router-dom';
import { ContractProvider } from '../contexts/ContractContext';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';


const ContractDetailPage: React.FC = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const charityId = useSelector((state: RootState) => state.auth.charity?._id)

  if (!id || !charityId) {
    navigate('/contracts')
    return null
  }

  return (<ContractProvider charityId={charityId} id={id}>
    <ContractDetail closeDetail={() => { navigate('/contracts') }} />
  </ContractProvider>)
};

export default ContractDetailPage;
